import { FileDownloadService } from './../../../../../shared/file-download/file-download.service';
import { BaseHttpService } from './../../../../../shared/base-http/base-http.service';
import { Injectable } from '@angular/core';
import { config } from '../../../../../../config/config';
import { getEnv } from '../../../../../../modules/utility';

@Injectable()
export class TprNecApiService {

    constructor(
        private readonly http: BaseHttpService,
        private readonly download: FileDownloadService
    ) { }

    public getTprNec(toolId) {
        const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/nec?toolId=${toolId}`;
        return this.http.get(url);
    }

    public updateTprNec(toolId: number, necLec: string, date: Date) {
        const dto = {
            toolId,
            necLec,
            necCompleteDate: date
        };

        const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/nec`;
        return this.http.put(url, dto);
    }


    public printNecReport(toolId: number, necLec: string, saveFile: boolean, tprToolId?: number, toolNo?: string, programName?: string, reportTag?: string) {
        const date = new Date().toLocaleDateString().replace(/\//g, '-');
        this.download.downloadFileWithBody(
            `${programName || ''}_${toolNo}_${reportTag}_NEC_${necLec}_${date}.pdf`,
            'ecm/report/nec/download',
            { toolId, necLec, saveFile, tprToolId }
        ).subscribe();
    }

}
